const initState = {
    'SchedulerProviderArray': [],
    'SelectedLocationArray': [],
    'SelectedAppointmentStatusArray': [],
    'SelectedAppointmentTypeArray': [],
};

const SchedulerProviderArrReducer = (state = initState, action) => {

    switch (action.type) {
        case 'SchedulerProviderArray': return { ...state, [action.type]: action.payload };
        case 'SelectedLocationArray': return { ...state, [action.type]: action.payload };
        case 'SelectedAppointmentStatusArray': return { ...state, [action.type]: action.payload };
        case 'SelectedAppointmentTypeArray': return { ...state, [action.type]: action.payload };
        default: return state;
    }
}
export default SchedulerProviderArrReducer;